export const sumArray = (arr) => arr.reduce((sum, val) => sum + val, 0);